import React from "react";

export const GridBackground = ({ className = "" }) => (
  <div
    className={`pointer-events-none absolute inset-0 grid-bg radial-fade ${className}`}
    aria-hidden="true"
  />
);

export const NeonGlowOrbs = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
    <div className="absolute -top-32 -left-24 h-96 w-96 rounded-full bg-neon-green/20 blur-[120px]" />
    <div className="absolute -bottom-32 -right-24 h-[28rem] w-[28rem] rounded-full bg-terminal-green/15 blur-[140px]" />
    <div className="absolute top-1/3 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-electric-blue/10 blur-[120px]" />
  </div>
);
